<p-sidebar [(visible)]="showSidebar"
           [position]="'right'"
           [baseZIndex]="10000"
           (onHide)="cancel()"
           [style]="{width:'750px'}">
    <ng-template pTemplate="header">Inquiry ID {{selectedInquiry.Id}}</ng-template>
    <p-scrollPanel [style]="{width:'100%', height: 'calc(71vh)', marginTop: '1%'}"
                   [styleClass]="'app-scrollpanel'">
        <p-tabMenu [model]="menuItems" [activeItem]="menuItems[0]"></p-tabMenu>
        <div class="customer-info-body">
            <p-scrollPanel 
                           [styleClass]="'app-scrollpanel'">
                <div class="inquiry-section-detail">
                    <div class="inquiry-details-info-header">Customer Details</div>
                    <div class="inquiry-detail">
                        <div>Name</div>
                        <div>{{selectedInquiry.CustomerName}}</div>
                    </div>
                    <div class="inquiry-detail">
                        <div>Email</div>
                        <div>{{selectedInquiry.Email}}</div>
                    </div>
                    <div class="inquiry-detail">
                        <div>Phone</div>
                        <div>{{selectedInquiry.Phone}}</div>
                    </div>
                </div>
                <div class="inquiry-section-detail">
                    <div class="inquiry-details-info-header">Boat Name/ID</div>
                    <div class="inquiry-detail">
                        <div>Name</div>
                        <div>{{selectedInquiry.BoatName}}</div>
                    </div>
                    <div class="inquiry-detail">
                        <div>Boat Size</div>
                        <div>{{selectedInquiry.Size}}</div>
                    </div>
                    <div class="inquiry-detail">
                        <div>Capacity</div>
                        <div>{{selectedInquiry.Capacity}}</div>
                    </div>
                    <div class="inquiry-detail">
                        <div>Feature</div>
                        <div [innerHTML]="selectedInquiry.Feature"></div>
                    </div>
                    <div class="inquiry-detail">
                        <div>Availability</div>
                        <div>{{selectedInquiry.Availability}}</div>
                    </div>
                    <div class="inquiry-detail">
                        <div>Price Range</div>
                        <div>{{selectedInquiry.PriceRange}}</div>
                    </div>
                </div>
                <div class="inquiry-section-detail">
                    <div class="inquiry-details-info-header">Inquiry Details</div>
                    <div class="inquiry-detail">
                        <div>Number of People</div>
                        <div>{{selectedInquiry.NumberOfPeople}}</div>
                    </div>
                    <div class="inquiry-detail">
                        <div>Rental Duration</div>
                        <div>{{selectedInquiry.RentalDuration}}</div>
                    </div>
                    <div class="inquiry-detail">
                        <div>Additional Comments</div>
                        <div>{{selectedInquiry.AdditionalComments}}</div>
                    </div>
                </div>
            </p-scrollPanel>
        </div>
    </p-scrollPanel>
</p-sidebar>


